import { NgModule } from '@angular/core';
import { WidgetSettingsControlAdvancedTextComponent } from './controls/advanced-text/advanced-text.component';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '../components/components.module';
import { UtilitiesModule } from '../utilities/utilities.module';
import { WidgetSettingsControlNewsFeedComponent } from './controls/news-feed/news-feed.component';
import { WidgetSettingsControlSitemapComponent } from './controls/sitemap/sitemap.component';
import { WidgetSettingsComponent } from './widget-settings.component';
import { WidgetSettingsControlForumListingComponent } from './controls/forum-listing/forum-listing.component';
import { WidgetSettingsControlForumFeedComponent } from './controls/forum-feed/forum-feed.component';
import { WidgetSettingsControlListingComponent } from './controls/listing/listing.component';
import { WidgetNumberOfRecordsToTakeComponent } from './number-of-records-to-take/number-of-records-to-take.component';
import { WidgetSettingsControlFormListingComponent } from '@fi-app/widget-settings/controls/form-listing/form-listing.component';
import { FiTextItemMediaPanelHandlerModule } from '@fi-app/utilities/insert-media/fi-text-item-media-panel-handler/fi-text-item-media-panel-handler.module';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiTextItemTablePanelHandlerModule } from '@fi-app/utilities/fi-text-item-table-panel-handler/fi-text-item-table-panel-handler.module';

@NgModule({
    imports: [
        CommonModule,
        MatCheckboxModule,
        MatRadioModule,
        MatFormFieldModule,
        MatSelectModule,
        MatCheckboxModule,
        FormsModule,
        FiAppTextSharedModule,
        ComponentsModule,
        UtilitiesModule,
        FiTextItemTablePanelHandlerModule,
        FiTextItemMediaPanelHandlerModule,
        MatInputModule,
        MatButtonModule,
        SelectSearchModule,
    ],
    declarations: [
        WidgetSettingsComponent,
        WidgetSettingsControlAdvancedTextComponent,
        WidgetSettingsControlNewsFeedComponent,
        WidgetSettingsControlSitemapComponent,
        WidgetSettingsControlForumListingComponent,
        WidgetSettingsControlForumFeedComponent,
        WidgetSettingsControlListingComponent,
        WidgetSettingsControlFormListingComponent,
        WidgetNumberOfRecordsToTakeComponent,
    ],
    exports: [WidgetSettingsComponent, WidgetSettingsControlSitemapComponent],
})
export class WidgetSettingsModule {}
